import { useContext } from "react";
import allsafeLogo from "../assets/icons/allsafe_logo.svg";
import bike from "../assets/images/bike.jpg";
import { useTranslation } from "react-i18next";
import { Context } from "../ContextProvider";

const Header = () => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useContext(Context);

  const handleLangChange = (e: any) => {
    const lang = e.target.value;
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <header data-testid="header">
      <div className="fixed flex justify-between items-center bg-allsafe-white shadow-md w-full z-20 h-24 pl-4 pr-8">
        <div className="h-16 w-16">
          <img src={allsafeLogo} alt="logo" className="w-full h-full" />
        </div>
        <div className="relative overflow-hidden">
          <select
            name="lang"
            id="lang"
            onChange={handleLangChange}
            value={language}
            className="font-Roboto cursor-pointer w-16 h-8 bg-allsafe-grey hover:bg-gray-200 shadow-3xl appearance-none bg-[url('./assets/icons/arrow.svg')] bg-no-repeat	bg-[90%_50%] rounded-md outline-none indent-2"
          >
            <option value="de">DE</option>
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select>
        </div>
      </div>
      <div className="relative top-24 h-48 sm:h-80 md:h-[533px]">
        <div className="h-full w-full absolute">
          <img
            className="w-full h-full object-cover object-[80%_80%] sm:object-[80%_64%]"
            src={bike}
            alt="bike"
          />
        </div>
        <div className="bg-allsafe-light-grey h-full w-full absolute top-0 mix-blend-multiply" />
      </div>
    </header>
  );
};

export default Header;
